import styled from 'styled-components';
import { Toast } from '@abc-intelligence/abc-ui';

export default styled(Toast)`
  font-size: 1.6rem;
`;
